import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { LOCAL_STORAGE } from '../../constants/local-storage.constants';
import { FlutterChannelService } from '../../services/flutter-channel.service';
import { FCMTokenService } from '../../services/fcmToken.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  riderName: string = '';
  riderContact: string = '';
  constructor(
    private router: Router,
    private authService: AuthService,
    private localStorage: LocalStorageService,
    private flutterChannelService: FlutterChannelService,
    private fcmTokenService: FCMTokenService
  ) {}

  ngOnInit() {
    const rider = this.localStorage.getItem(LOCAL_STORAGE.RIDER);
    if (rider) {
      this.riderName = rider.name;
      this.riderContact = rider.primaryContact;
    }
  }

  async navigateToRoute(url: string) {
    this.router.navigate([url]);
  }

  logout() {
    if (this.localStorage.getItem(LOCAL_STORAGE.DEVICE_ID)) {
      this.fcmTokenService.deleteFCMToken().subscribe((res) => {
        this.sendLogoutEventToFlutter();
        this.authService.logout();
      });
    } else {
      this.sendLogoutEventToFlutter();
      this.authService.logout();
    }
  }

  sendLogoutEventToFlutter() {
    const data = {
      event: 'onLogout',
    };
    this.flutterChannelService.sendDataToFlutter(data);
  }
}
